<div class="mb-3" *ngIf="choices">
    <fieldset class="row justify-content-between">
        <div class="col-auto col-sm-6 d-flex flex-column flex-sm-row gap-2">
            <span class="choices" *ngIf="choices.choicePositive as choice">
                <pace-forms-input-radio
                    [label]="choice.label"
                    [value]="choice.xmlId"
                    [name]="choice.xmlId"
                    [disabled]="disabled"
                    [ngModel]="selectedValue"
                    (ngModelChange)="onChanged($event)"
                ></pace-forms-input-radio>
            </span>
            <span class="choices" *ngIf="choices.choiceNegative as choice">
                <pace-forms-input-radio
                    [label]="choice.label"
                    [value]="choice.xmlId"
                    [name]="choice.xmlId"
                    [disabled]="disabled"
                    [ngModel]="selectedValue"
                    (ngModelChange)="onChanged($event)"
                ></pace-forms-input-radio>
            </span>
            <span class="choices" *ngIf="choices.choiceNa as choice">
                <pace-forms-input-radio
                    [label]="choice.label"
                    [value]="choice.xmlId"
                    [name]="choice.xmlId"
                    [disabled]="disabled"
                    [ngModel]="selectedValue"
                    (ngModelChange)="onChanged($event)"
                ></pace-forms-input-radio>
            </span>
        </div>
        <div class="col-auto col-sm-6 align-self-end pe-0">
            <button
                class="btn btn-link"
                *ngIf="(choices.choicePositive || choices.choiceNegative || choices.choiceNa) && !disabled"
                (click)="reset()"
                translate="STANDARD_FUNCTIONAL_ELEMENT_RESET_BUTTON_LABEL"
            ></button>
        </div>
    </fieldset>
</div>
